import { render, staticRenderFns } from "./ResourcesIcon.vue?vue&type=template&id=7dfa4b2c"
import script from "./ResourcesIcon.vue?vue&type=script&lang=js"
export * from "./ResourcesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports